export default {
  'PUBLICASKING' (state) {
    return state.publicAsking
  },
  'PUBLICASKINGS' (state) {
    return state.publicAskings
  }
}
